import apiClient from "../api_client/apiClient";

export const analyticsService = {
  track: (name, category = "app", properties = {}) => apiClient.post("/genesis/analytics/events", { name, category, properties }),
  mine: (limit = 100) => apiClient.get("/genesis/analytics/events/me", { limit }),
};
